import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c76723c")

_pushScopeId("data-v-4c76723c")
const _hoisted_1 = { class: "analysis-main" }
const _hoisted_2 = { class: "contain flex flex-row" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "question" }
const _hoisted_5 = { class: "div" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_analysisHeader = _resolveComponent("analysisHeader")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_analysisHeader, {
      name: _ctx.analysis.jobName,
      view: _ctx.jobView,
      onOnBack: _ctx.goBack,
      onOnSubmit: _ctx.onSubmit
    }, null, 8, ["name", "view", "onOnBack", "onOnSubmit"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_spin, {
          class: "spin",
          spinning: _ctx.basicLoading
        }, null, 8, ["spinning"]),
        _withDirectives(_createVNode("div", {
          class: "info-dom",
          innerHTML: _ctx.analysis.jobInfomation
        }, null, 8, ["innerHTML"]), [
          [_vShow, !_ctx.basicLoading]
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_a_spin, {
          class: "spin",
          spinning: _ctx.qLoading
        }, null, 8, ["spinning"]),
        _withDirectives(_createVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "question")
        ], 512), [
          [_vShow, !_ctx.qLoading]
        ])
      ])
    ])
  ]))
})